module.exports = __webpack_public_path__ + "static/media/iconMale.a297075a.svg";